(async () => {

  if (!customElements.get('quickshop-drawer')) {

    class QuickshopDrawer extends HTMLElement {
      constructor() {
        super();

        // Catch click on data-quickshop-close
        this.addEventListener('click', (e) => {
          e.stopPropagation();
          if (e.target.hasAttribute('data-quickshop-close')) {
            this.close();
          }
        });
      }

      // Open the drawer
      open(){
        this.classList.add('is--open');
      }

      // Close the drawer
      close(){
        this.classList.remove('is--open');
      }
    }

    window.QuickshopDrawer = QuickshopDrawer;

    customElements.define('quickshop-drawer', QuickshopDrawer);

  }

})();
